import { useEffect, useRef } from "react";

import { CreateSessionStatuses } from "../context/BookingContext";
import { sendNativeMessage } from "../utils/sendNativeMessage";

type CreateSessionStatus =
  (typeof CreateSessionStatuses)[keyof typeof CreateSessionStatuses];

export type NativeBookingEventPayload = {
  sessionId?: number;
  sessionStartTime?: string;
  previousSessionId?: number;
};

export const useNativeBookingEvents = (
  status: CreateSessionStatus | undefined,
  payload?: NativeBookingEventPayload,
): void => {
  const prevStatus = useRef(status);

  useEffect(() => {
    if (status === prevStatus.current) return;
    prevStatus.current = status;

    if (status === CreateSessionStatuses.SUCCESS) {
      sendNativeMessage({
        eventName: "BOOKING_SUCCESS",
        sessionId: payload?.sessionId,
        sessionStartTime: payload?.sessionStartTime,
        previousSessionId: payload?.previousSessionId,
      });
    }

    if (status === CreateSessionStatuses.ERROR) {
      sendNativeMessage({
        eventName: "BOOKING_ERROR",
        previousSessionId: payload?.previousSessionId,
      });
    }
  }, [
    status,
    payload?.sessionId,
    payload?.sessionStartTime,
    payload?.previousSessionId,
  ]);
};
